import React from "react";
import { YesNoPanel } from "../../../components/wizards/YesNoPanel";
import { WizardContext } from "../WizardContext";

export const MedicalReviewCompleteScreen = () => (
  <WizardContext.Consumer>
    {({ dispatch }) => (
      <>
        <YesNoPanel
          question="Has medical review been completed?"
          yesAction={() => {
            dispatch({
              type: "setAnswer",
              key: "medicalReviewComplete",
              value: true,
              doTransition: true,
            });
          }}
          noAction={() => {
            dispatch({
              type: "setAnswer",
              key: "medicalReviewComplete",
              value: false,
              doTransition: true,
            });
          }}
        />
      </>
    )}
  </WizardContext.Consumer>
);
